import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

function index(props) {
  return (
    <Wrapper abierto={props.abierto} className="submenu">
      <div className="container">
        {props.data
          ? props.data.map((item, key) => {
              const { title, img, url } = item
              return (
                <Item className="Link__Submenu" to={url} key={key}>
                  <img src={img} alt={title} />
                  <h3>{title}</h3>
                </Item>
              )
            })
          : null}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.amarillo};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;
  box-shadow: inset 0 6px 10px 0 rgba(0, 0, 0, 0.1),
    0 10px 8px 0 rgba(0, 0, 0, 0.1);
  img {
    width: 100%;
    height: 230px;
    object-fit: contain;
  }
  h3 {
    color: ${({ theme }) => theme.colors.azul};
    font-family: "aller";
  }
  .container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    padding: 1rem 2rem;
  }

  @media (max-width: 1000px) {
    position: static;
    background-color: ${({ theme }) => theme.colors.azul};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
    max-height: ${({ abierto }) => (abierto ? "100%" : "0px")};
    h3 {
      color: ${({ theme }) => theme.colors.amarillo};
      text-align: center;
      font-size: 100%;
      margin: 0.5rem 0;
    }
    .container {
      display: block;
    }
    .Link__Submenu h3 {
      border: 1px solid ${({ theme }) => theme.colors.amarillo};
      border-radius: 20px;
      padding: 0.5rem 0.8rem;
      color: ${({ theme }) => theme.colors.blanco};
      margin: 0.4rem 0;
      transition: all 0.3s;
      font-size: 0.8rem;
      font-weight: normal;
      :hover {
        background-color: ${({ theme }) => theme.colors.blanco};
        color: ${({ theme }) => theme.colors.azul};
        transition: all 0.3s;
      }
    }
    .Link__Submenu img {
      display: none;
    }
  }
`

const Item = styled(Link)`
  align-self: end;
  text-align: center;
  img {
    transition: transform 0.3s ease;
  }
  &:hover img {
    transform: scale(0.92);
  }
`

export default index
